
import { type CTNTabContentProps } from '@ctn/ui/types/ctn-tab';
import { useMemo, useState } from 'react';

import GoogleMapsWrapper from '@/context/Maps/googleMapsWrapper.context';

import { type INotaria } from '@/interfaces/model/TramiteNuevo/INotaria.interface';

import MapNotariesLocations from './MapNotariesLocations';
import SearchNotaryView from './SearchNotaryView';
import SeleccionDeFormato from '../components/SeleccionDeFormato';

type SearchNotaryProps = {
	readonly setSelectedNotary: (notary: INotaria) => void;
};


const SeleccionDeNotario = ( { setSelectedNotary }: SearchNotaryProps) => {
	const [foundNotaries, setFoundNotaries] = useState<INotaria[]>([]);
	const selectedTab = 0;
	const [totalResults, setTotalResults] = useState<number | undefined>(undefined);
	const [page, setPage] = useState(1);
	const [errorMessage, setErrorMessage] = useState<string>('');

	const tabs: Array<CTNTabContentProps & { key: string }> = useMemo(() => [
		{
			key: 'search',
			header: 'Buscador de notarios',
			icon: [{ 
				color: 'blue',
				icon: 'search',
				position: 'left',
			}],
			badge: (totalResults ?? 0) > 0 
				? {
					color: 'red',
					content: String(totalResults), 
					size: 'lg',
				} 
				: undefined, 
			content: (
				<SearchNotaryView
					foundNotaries={foundNotaries}
					setFoundNotaries={setFoundNotaries}
					totalResults={totalResults}
					setTotalResults={setTotalResults}
					page={page}
					setPage={setPage}
					setSelectedNotary={setSelectedNotary}
					errorMessage={errorMessage}
				/>
			),
		},
		{
			key: 'map',
			header: 'Ver en el mapa',
			icon: [{
				color: 'blue',
				icon: 'poi',
				position: 'left',
			}],
			content: (
				<GoogleMapsWrapper>
					<MapNotariesLocations
						foundNotaries={foundNotaries}
						setSelectedNotary={setSelectedNotary}
					/>
				</GoogleMapsWrapper>
			),
		},
	], [foundNotaries, totalResults, page, errorMessage, setSelectedNotary, setErrorMessage, setFoundNotaries, setPage, setTotalResults]);

	const renderSelectedTab = () => tabs[selectedTab].content;

	return (
		<div className='c-pnm-search-notary'>
			<div className="c-pnc-search-notary-modal__tabs-content">
				{renderSelectedTab()}
			</div>
			<SeleccionDeFormato />
		</div>
	);
};

export default SeleccionDeNotario;
